<template>
  <div class="ad">
    <h2>在三泰，享高效</h2>
    <p>有一个想法？我们在这里帮助你的工作</p>
    <span @click="goto">联系我们</span>
  </div>
</template>
<script>
export default {
  methods: {
    goto() {
      window.location.href = 'https://www.scyllai.com/mailForm.html'
    }
  }
}
</script>
<style lang="stylus" scoped>
.ad {
  height: 300px;
  background: url("~@/assets/img/home/ad/contact-us-shading.svg") top left no-repeat;
  background-size: cover;
  color: #fff;
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  & h2 {
    height: 70px;
    font-size: 36px;
    font-weight: 400;
    line-height: 50px;
    color: #FFFFFF;
  }
  & p {
    font-size: 18px;
    margin: 28px 0 37px;
    line-height: 25px;
  }
  & span {
    cursor: pointer;
    display: inline-block;
    width: 252px;
    height: 56px;
    line-height: 56px;
    font-size: 18px;
    border: 1px solid #FFFFFF;
    opacity: 1;
    border-radius: 2px;
  }
  & span:hover {
    background: #FFFFFF;
    color: #0061FD;
  }
}
</style>
